import { AlertCircle } from 'lucide-react';

export const ErrorBanner = (props: { message: string }) => {
  return (
    <div className="flex-none p-4">
      <div className="flex items-center gap-2 rounded-lg bg-red-200 p-4 text-red-700">
        <AlertCircle className="size-5" />
        <span>{props.message}</span>
      </div>
    </div>
  );
};
